export default (theme) => ({
  title: {
    color: theme.color.white,
    textAlign: 'center',
    position: 'absolute',
    top: theme.spacing(3),
    width: '100%',
  },
  cropContainer: {
    display: 'flex',
    background: theme.color.black,
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
  },
  cropButtons: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    '& button': {
      background: 'none',
      border: 0,
      color: theme.color.white,
      cursor: 'pointer',
      fontSize: '20px',
      margin: theme.spacing(2),
    },
  },
  imageWarning: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    flexDirection: 'column',
    '& h4': {
      padding: theme.spacing(0, 0, 2),
    },
  },
});
